import { FaCopy, FaCheck } from 'react-icons/fa';
import { useState } from 'react';

export default function CopyButton({ shareData }) {
  const [isCopy, setIsCopy] = useState(false);

  const copyUrlToClipboard = () => {
    navigator.clipboard
      .writeText(shareData)
      .then(() => {
        setIsCopy(true);
      })
      .catch((err) => {
        console.error('Failed to copy URL: ', err);
      });
  };

  return (
    <button
      onClick={copyUrlToClipboard}
      className=" rounded-xl border border-1 border-blue-300 border-info p-2 my-4"
    >
      {isCopy ? (
        <span>
          <FaCheck className="inline" /> Copied{' '}
        </span>
      ) : (
        <span>
          Copy Link <FaCopy className="inline" />
        </span>
      )}
    </button>
  );
}
